import s from './BreedsDetail.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { NavigationHeader } from 'components/NavigationHeader/NavigationHeader';
import { BackButton } from 'components/BackButton/BackButton';
import { BreedsLabel } from 'components/MenuLabels/BreedsLabel/BreedsLabel';
import { BreedIdLabel } from 'components/BreedIdLabel/BreedIdLabel';
import { BreedInfoDetail } from 'components/BreedDetailInfo/BreedDetailInfo';
import { fetchBreedByName } from 'services/API/API';

import { useState } from 'react';
import { useEffect } from 'react';

const BreedsDetail = () => {
  const { pathname } = useLocation();

  const [catId, setCatId] = useState(pathname.slice(8));

  const images = handlerImages(catId);

  function handlerImages(catId) {
    let images = JSON.parse(localStorage.getItem('images'));
    const imageClick = images.find(({ id }) => id === catId);
    const imageIndex = images.indexOf(imageClick);
    const numberOfImages = images.length;
    const cutImages = images.splice(imageIndex, numberOfImages - imageIndex);
    images = [...cutImages, ...images];
    return images;
  }

  function getBreedName(index) {
    if (!images[index].breeds[0]) {
      return 'No breed';
    }
    return images[index].breeds[0].name;
  }

  const [breed, setBreed] = useState(getBreedName(0));

  const [breedInfo, setBreedInfo] = useState(null);

  useEffect(() => {
    fetchBreedByName(breed).then(data => setBreedInfo(data[0]));
  }, [breed]);

  const location = useLocation();

  const navigate = useNavigate();

  const queryHandler = query => {
    fetchBreedByName(query).then(data => {
      if (data.length) {
        navigate('/search', {
          replace: true,
          state: { breed: data[0].id, path: pathname, query },
        });
      } else {
        navigate('/search', {
          replace: true,
          state: { breed: '', path: pathname, query, images: [] },
        });
      }
    });
  };

  return (
    <div className={s.main}>
      <NavigationHeader onSearch={queryHandler} />

      <div className={s.container}>
        <div className={s.navigation}>
          <BackButton path={location.state ? location.state.path : '/'} />
          <BreedsLabel />
          <BreedIdLabel catId={catId} />
        </div>
        <div>
          <Carousel
            width={640}
            infiniteLoop={true}
            showThumbs={false}
            onChange={e => {
              const catId = images[e].id;
              const breed = getBreedName(e);
              setCatId(catId);
              setBreed(breed);
            }}
          >
            {images.map(({ url, id }, index) => {
              return (
                <>
                  <div id={id} key={id}>
                    <img
                      key={id}
                      src={url}
                      width={680}
                      height={360}
                      style={{ objectFit: 'cover' }}
                      className={s.catImage}
                      alt={'cat'}
                    />
                  </div>
                </>
              );
            })}
          </Carousel>
        </div>
        <div>
          {breedInfo ? (
            <BreedInfoDetail
              breed={breedInfo.name}
              temperament={breedInfo.temperament}
              describe={breedInfo.description}
              origin={breedInfo.origin}
              weight={breedInfo.weight.metric || breedInfo.weight.imperial}
              life={breedInfo.life_span}
            />
          ) : (
            <BreedInfoDetail
              breed={'No info about breed'}
              temperament={'No info about breed'}
              describe={'No info about breed'}
              origin={'No info about breed'}
              weight={'No info about breed' || 'No info about breed'}
              life={'No info about breed'}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export { BreedsDetail };
